import React from 'react';

const Arrow = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
      <path
        d="M1.12354 11.6265L11.3765 1.37354M11.3765 1.37354L1.50199 1.37354M11.3765 1.37354V11.248"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Arrow;
